<div class="card">
  <div class="card-header card-header-dark d-flex">
    <span class="mr-2">{{'FORWARDED_ALERTS' |translate}}</span>
    <app-notification-badge [count]="$safeNavigationMigration(alerts?.length)" [warningStatus]="false"
    style="margin-top: 3px;"></app-notification-badge>
  </div>
  <mat-accordion multi class="card-body card-body-dark" cdkDropList id="forwardedAlertList" [cdkDropListData]="alerts"
    (cdkDropListDropped)="crService.drop($event)">
    @for (alert of alerts; track alert.alertId) {
      <mat-expansion-panel cdkDrag [cdkDragDisabled]="!alert.allowTransition"
        class="mb-2" [expanded]="hasNoteText(alert.noteCache)">
        <mat-expansion-panel-header
          [ngClass]="{'alertCardHeaderWithDrag': alert.allowTransition, 'alertCardTransitional': alert.transitional}"
          cdkDragHandle class="justify-content-between">
          <div class="container my-2">
            <div class="row" [style.alignItems]="'center'">
              <i
                class="fa-2x {{alert.iconResponse?.iconClass}} mr-2"
                [style.color]="alert.iconResponse?.color"
              ></i>
              <div class="w-25 mr-2"><strong>{{alert.header}} ({{alert.productId}})</strong></div>
              <div class="alignItemsToCenter">
                <p class="mr-4"> {{ alert | pickUpActivationName }}</p>
              </div>
              <div class="alignItemsToCenter">
                <p><small><i>{{alert.time | calculateAlertTime}}</i></small></p>
              </div>
              @if (alert.increment > 0) {
                <div
                  class="w-25 text-center"
                  (click)="crSync.resetAlertIncrement(alert.userId, alert.alertId)"
                  matTooltip="{{'INCREMENT_INFO' |translate}} {{'CLICK_TO_RESET' |translate}}"
                  [matTooltipPosition]="'above'"
                  >
                  <span class="badge badge-pill badge-danger">{{'+' + alert.increment}}</span>
                </div>
              }
            </div>
            <div class="row mt-2 ml-2">
              <p><strong>{{'STATUS' |translate}}:</strong> {{getAlertStatus(alert)}} @if (alert.state !== emaAlertState.Available) {
              <span
                class="fa-solid fa-xs fa-circle"
              [ngClass]="{'text-danger': !getStaffDetails(alert, 2), 'text-success': getStaffDetails(alert, 2)}"></span>
            }
          </p>
        </div>
      </div>
    </mat-expansion-panel-header>
    <div class="alertCardBody clearfix">
      <div>
        <p><span class="fa-light fa-lg fa-fw fa-location-dot"></span>&nbsp;&nbsp;{{alert.address}}</p>
      </div>
      @if (alert.place) {
        <div class="mt-2">
          <p><span class="fa-light fa-lg fa-fw fa-microchip"></span>&nbsp;&nbsp;{{alert.place}}</p>
        </div>
      }
      <app-customer-rules [customerId]="alert.customerId" [serverId]="alert.alertId"></app-customer-rules>
      <div>
        <app-display-alarm-reasons
          [alert]="alert"
          [dataComesFromSocket]="true">
        </app-display-alarm-reasons>
        <app-add-note [alert]="alert" [noteText]="alert.noteCache" (noteTextKeeped)="handleNoteText($event, alert.alertId)"></app-add-note>
      </div>
      <div class="mt-3">
        @if (alert.state !== emaAlertState.Available && getStaffDetails(alert, 0)) {
          <p class="mb-2"><a
            href="{{'tel:' + getStaffDetails(alert, 0)}}" class="cursorPointerHover"><span
          class="fa-light fa-fw fa-phone"></span>&nbsp;&nbsp;{{'CALL_NURSE' |translate}}:
        {{getStaffDetails(alert, 0)}}</a></p>
      }
      @if (alert.baseMISDN) {
        <p data-testid="call-patient-link" class="mb-2"><a href="{{'tel:' + alert.baseMISDN}}" class="cursorPointerHover"><span
        class="fa-light fa-fw fa-phone"></span>&nbsp;&nbsp;{{'CALL_PATIENT' |translate}}:
      {{alert.baseMISDN}}</a></p>
    }
  </div>
  <hr>
    <div class="mt-3">
      @if (alert.customerName) {
        <p class="mt-2">
          <span
          class="fa-light fa-fw fa-building"></span>&nbsp;&nbsp;{{alert.customerName}},&nbsp;{{alert.locationName}}
        </p>
      }
      <div class="d-flex mt-2 justify-content-end">
        <app-phonebook-button [customerId]="alert.customerId" [serverId]="alert.alertId"></app-phonebook-button>
      </div>
    </div>
  </div>
</mat-expansion-panel>
}
</mat-accordion>

@if (showTeamAlerts) {
  <div>
    <div class="card-header card-header-dark">{{'ALERT_FORWARDED_BY_OTHERS' |translate}} ({{teamsAlerts.length}})
    </div>
    <mat-accordion multi class="card-body card-body-dark d-block" cdkDropList id="forwardedAlertList"
      [cdkDropListData]="alerts"
      (cdkDropListDropped)="crService.drop($event)">
      @for (alert of teamsAlerts; track alert.alertId) {
        <mat-expansion-panel>
          <mat-expansion-panel-header class="justify-content-between">
            <i
              class="fa-2x {{alert.iconResponse?.iconClass}} mr-2"
              [style.color]="alert.iconResponse?.color"
            ></i>
            <div class="w-25">
              <p class="mr-2"><strong>{{alert.header}} ({{alert.productId}})</strong></p>
            </div>
            <div>
              <p class="mr-2"> {{ alert | pickUpActivationName }}</p>
            </div>
            <div>
              <small>{{alert.time | calculateAlertTime}}</small>
            </div>
            @if (alert.increment > 0) {
              <div class="cursorPointer w-25 text-center"
                (click)="crSync.resetAlertIncrement(alert.userId, alert.alertId)"
                matTooltip="{{'INCREMENT_INFO' |translate}} {{'CLICK_TO_RESET' |translate}}"
                [matTooltipPosition]="'above'">
                <span class="badge badge-pill badge-danger">{{'+' + alert.increment}}</span>
              </div>
            }
          </mat-expansion-panel-header>
          <div class="alertCardBody clearfix">
            <div>
              <p><span class="fa-light fa-lg fa-fw fa-location-dot"></span>&nbsp;&nbsp;{{alert.address}}
            </p>
          </div>
          <div class="mt-3">
            <p><strong>{{'STATUS' |translate}}:</strong> {{getAlertStatus(alert)}} @if (alert.state !== emaAlertState.Available) {
            <span
              class="fa-solid fa-xs fa-circle"
            [ngClass]="{'text-danger': !getStaffDetails(alert, 2), 'text-success': getStaffDetails(alert, 2)}"></span>
          }
        </p>
      </div>
      <div>
        <app-add-note [alert]="alert"></app-add-note>
      </div>
      <div class="mt-3">
        @if (alert.state !== emaAlertState.Available && getStaffDetails(alert, 0)) {
          <p class="mb-2"
            ><a
            href="{{'tel:' + getStaffDetails(alert, 0)}}" class="cursorPointerHover"><span
          class="fa-light fa-fw fa-phone"></span>&nbsp;&nbsp;{{'CALL_NURSE' |translate}}:
        {{getStaffDetails(alert, 0)}}</a></p>
      }
      @if (alert.baseMISDN) {
        <p data-testid="call-patient-link" class="mb-2"><a href="{{'tel:' + alert.baseMISDN}}" class="cursorPointerHover"><span
        class="fa-light fa-fw fa-phone"></span>&nbsp;&nbsp;{{'CALL_PATIENT'
      |translate}}: {{alert.baseMISDN}}</a></p>
    }
  </div>
  <hr>
    <div class="mt-3">
      @if (alert.customerName) {
        <p class="mt-2"><span
        class="fa-light fa-fw fa-building"></span>&nbsp;&nbsp;{{alert.customerName}},&nbsp;{{alert.locationName}}
      </p>
    }
  </div>
</div>
</mat-expansion-panel>
}
</mat-accordion>
</div>
}
</div>
